import VideoChat from './VideoChat';

export default VideoChat;
